import React from 'react';
import styled from 'styled-components';
import { StepContent, StepTitle, StepSummary, VerticalRule } from '../shared';
const SectionLandmark = styled.section `
  display: flex;
  flex-direction: column;
`;
const StepWrapper = styled.div `
  ${({ theme: { space } }) => `
    display: flex;
    flex-direction: column;
    margin-bottom: ${space.xs};
  `}
`;
const StepContentWrapper = styled.div `
  display: flex;
`;
const VerticalSteppedProcess = ({ steps, a11y, }) => {
    return (React.createElement(SectionLandmark, { "aria-label": a11y === null || a11y === void 0 ? void 0 : a11y.ariaLabelSection }, steps.map((step, index) => (React.createElement(StepWrapper, { key: step.id },
        React.createElement(StepTitle, { stepIndex: index, step: step, getAriaLabelStepTitle: a11y === null || a11y === void 0 ? void 0 : a11y.getAriaLabelStepTitle }),
        React.createElement(StepContentWrapper, null,
            React.createElement(VerticalRule, { stepIndex: index }),
            React.createElement(StepSummary, { stepIndex: index, step: step }),
            React.createElement(StepContent, { stepIndex: index, step: step })))))));
};
export { VerticalSteppedProcess };
//# sourceMappingURL=VerticalSteppedProcess.js.map